import Vue from 'vue'
import VueRouter from 'vue-router'
import Landesverband from '../views/landesverband/landesverband'
import SearchSpieler from '../views/searchSpieler/searchSpieler'
import VereinsReporting from '../views/vereine/vereinsReporting'
import SpielerExport from '../views/spielerExport/spielerExport'
import SpielerLoeschen from '../views/massDelete/massDelete'
import DataConversion from '../views/dataConversion/dataConversion'
import Paesse from '../views/paesse/paesse'
import Home from '../views/home/home'
// Ergebnisdienst
import RegionSelection from '../views/ergebnisdienst/regionSelection'
import Region from '../views/ergebnisdienst/region'
import LiveSpiele from '../views/ergebnisdienst/liveSpiele'
import Spielberichte from '../views/ergebnisdienst/spielbericht/spielBerichte'
import Vereinsdatenblatt from '../views/ergebnisdienst/vereinsdatenblatt/vereinsdatenblattDisplay'
import Bestaetigungen from '../views/ergebnisdienst/bestaetigungen/bestaetigungen'
import PrintTabellen from '../views/ergebnisdienst/print/printTabellen'
import PrintTabelle from '../views/ergebnisdienst/print/printTabelle'
import PrintSpiele from '../views/ergebnisdienst/print/printSpiele'
import PrintSchnittliste from '../views/ergebnisdienst/print/printSchnittliste'
import DummyVereine from '../views/ergebnisdienst/dummyVereine/dummyVereine'
import Help from '../views/ergebnisdienst/help/help'
import UserAdmin from '../components/userAdmin/userAdmin'
import PrintMaL from '../views/ergebnisdienst/spielbericht/print/spielBerichtPrintMaL'
import PrintSpB from '../views/ergebnisdienst/spielbericht/print/spielBerichtPrintSpB'
import PrintSpBKomm from '../views/ergebnisdienst/spielbericht/print/spielBerichtPrintSpBKommentar'
import PrintSrBlatt from '../views/ergebnisdienst/spielbericht/print/spielBerichtPrintSrBlatt'
import PrintWurfzettel from '../views/ergebnisdienst/spielbericht/print/spielBerichtPrintWurfzettel'
import PrintMeisterschaft from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrint.vue";
import PrintDatenblatt from '../views/ergebnisdienst/vereinsdatenblatt/vereinsdatenblattPrint'
import ShowTv from '../views/ergebnisdienst/spielbericht/tv/tvDisplay'
import Stream from '../views/ergebnisdienst/spielbericht/stream/stream'
//import BackUp from '../_backup/backUp'
// DATA CONVErSION
//import PassNrProLV from '../views/dataConversion/2023PassNrProLV'
//import KundenMeister from '../views/dataConversion/2023Kundenmeister'

Vue.use(VueRouter);

const routes = [
    /*{
        path: '/backup',
        name: 'backup',
        component: BackUp
    },*/
    { path: '/', name: 'Home', component: Home},
    { path: '/Ergebnisdienst/LiveSpiele', name: 'LiveSpiele', component: LiveSpiele },
    { path: '/Landesverband', name: 'Landesverband', component: Landesverband },
    { path: '/Spielersuche', name: 'SearchSpieler', component: SearchSpieler },
    { path: '/SpielerExport', name: 'SpielerExport', component: SpielerExport },
    { path: '/SpielerLoeschen', name: 'SpielerLoeschen', component: SpielerLoeschen },
    { path: '/Vereinsreporting', name: 'Vereinsreporting', component: VereinsReporting },
    { path: '/DataConversion', name: 'DataConversion', component: DataConversion },
    { path: '/Paesse', name: 'Paesse', component: Paesse },
    { path: '/Ergebnisdienst', name: 'Auswahl', component: RegionSelection },
    { path: '/Ergebnisdienst/Verband/:id', name: 'Region', component: Region, props: true },//
    { path: '/Ergebnisdienst/Spielberichte', name: 'Spielberichte', component: Spielberichte },
    { path: '/Ergebnisdienst/SpielberichteFremd', name: 'SpielberichteFremd', component: Spielberichte },
    { path: '/Ergebnisdienst/Vereinsdatenblatt', name: 'Vereinsdatenblatt', component: Vereinsdatenblatt },
    { path: '/Ergebnisdienst/AntiDoping', name: 'AntiDoping', component: Bestaetigungen },
    { path: '/Ergebnisdienst/PrintTabellen', name: 'PrintTabellen', component: PrintTabellen },
    { path: '/Ergebnisdienst/PrintSpiele', name: 'PrintSpiele', component: PrintSpiele },
    { path: '/Ergebnisdienst/PrintSchnittliste', name: 'PrintSchnittliste', component: PrintSchnittliste },
    { path: '/Ergebnisdienst/PrintTabelle', name: 'PrintTabelle', component: PrintTabelle },
    { path: '/Ergebnisdienst/DummyVereine', name: 'DummyVereine', component: DummyVereine },
    { path: '/Ergebnisdienst/PrintMaL', name: 'PrintMaL', component: PrintMaL },
    { path: '/Ergebnisdienst/PrintSpB', name: 'PrintSpielbericht', component: PrintSpB },
    { path: '/Ergebnisdienst/PrintSpBKomm', name: 'PrintSpielberichtKommentar', component: PrintSpBKomm },
    { path: '/Ergebnisdienst/PrintSpBLeer', name: 'PrintSpielberichtLeer', component: PrintSpB },
    { path: '/Ergebnisdienst/PrintSrBlatt', name: 'PrintSrBlatt', component: PrintSrBlatt },
    { path: '/Ergebnisdienst/PrintWurfzettel', name: 'PrintWurfzettel', component: PrintWurfzettel },
    { path: '/Ergebnisdienst/PrintDatenblatt', name: 'PrintDatenblatt', component: PrintDatenblatt },
    { path: '/Ergebnisdienst/PrintMeisterschaft', name: 'PrintMeisterschaft', component: PrintMeisterschaft,
        meta: {title: 'Meisterschaft'}},
    { path: '/Ergebnisdienst/showTv', name: 'ShowTv', component: ShowTv },
    { path: '/Ergebnisdienst/Stream', name: 'Stream', component: Stream },
    { path: '/Ergebnisdienst/Hilfe', name: 'Help', component: Help },
    { path: '/Ergebnisdienst/UserAdmin', name: 'UserAdmin', component: UserAdmin },
// DATA CONVErSION
    /*
    { path: '/PassNrProLV', name: 'PassNrProLV', component: PassNrProLV },
    { path: '/KundenMeister', name: 'KundenMeister', component: KundenMeister },*/

];

const router = new VueRouter({
  routes
});

router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        console.log ("to.path", to.path );
        document.title = to.path === "/Ergebnisdienst/PrintMeisterschaft" && to.query.docName ? to.query.docName :
                         to.path.indexOf("/Ergebnisdienst")===0 ? "ÖSKB Ergebnisdienst" : "ÖSKB App";
    });
});

export default router
